export default __webpack_public_path__ + "static/media/givetake.829a3a50.jpg";